:host {

    div.container {
        position: relative;
    }
    gauge-component {
    }
    counter-component  {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
